import React from "react";
import first_place_medal from "assets/emojis/1st-place-medal.png";
import check_mark_button from "assets/emojis/check-mark-button.png";
import credit_card from "assets/emojis/credit-card.png";
import crescent_moon from "assets/emojis/crescent-moon.png";
import crown from "assets/emojis/crown.png";
import globe_with_meridians from "assets/emojis/globe-with-meridians.png";
import hammer_and_wrench from "assets/emojis/hammer-and-wrench.png";
import locked from "assets/emojis/locked.png";
import money_with_wings from "assets/emojis/money-with-wings.png";
import party_popper from "assets/emojis/party_popper.png";
import raising_hands from "assets/emojis/raising-hands.png";
import ringed_planet from "assets/emojis/ringed-planet.png";
import rocket from "assets/emojis/rocket.png";
import satellite from "assets/emojis/satellite.png";
import sun from "assets/emojis/sun.png";
import telephone from "assets/emojis/telephone.png";
import television from "assets/emojis/television.png";
import tear_off_calendar from "assets/emojis/tear-off-calendar.png";
import high_voltage from "assets/emojis/high-voltage.png";
import money_bag from "assets/emojis/money-bag.png";

const localEmojis = {
  "1f947": first_place_medal,
  "2705": check_mark_button,
  "1f4b3": credit_card,
  "1f319": crescent_moon,
  "1f451": crown,
  "1f310": globe_with_meridians,
  "1f6e0": hammer_and_wrench,
  "1f512": locked,
  "1f4b8": money_with_wings,
  "1f389": party_popper,
  "1f64c": raising_hands,
  "1fa90": ringed_planet,
  "1f680": rocket,
  "1f6f0": satellite,
  "2600": sun,
  "260e": telephone,
  "1f4fa": television,
  "1f4b0": money_bag,
  "1f4c6": tear_off_calendar,
  "26a1": high_voltage,
};

const toUnicode = (emoji) => {
  return emoji?.codePointAt(0)?.toString(16);
};

export const toEmoji = (emoji, height = 16, overrideStyle = {}) => {
  const unicode = toUnicode(emoji);
  if (!unicode) {
    return null;
  }

  if (unicode in localEmojis) {
    return (
      <img
        alt={emoji}
        src={localEmojis[unicode]}
        style={{
          width: height,
          height,
          display: "inline",
          verticalAlign: "top",
          ...overrideStyle,
        }}
      />
    );
  }
  return emoji;
};